import axios from "axios";
const api = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_API_URL ||
    "https://duapi.proglogixconsularsuite.com/api/v1",

  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-API-Key": process.env.INTERNAL_API_KEY, // ⚠️ exposed
  },

  // 👇 Send cookies for Next.js middleware
  withCredentials: true,
});

// Attach Bearer token also
export const setAuthToken = (token) => {
  if (!token) {
    delete api.defaults.headers.common["Authorization"];
    return;
  }

  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  document.cookie = `auth_token=${token}; path=/;`; // cookie for middleware
};

export default api;
